import * as React from "react";
import { RadiosEditor } from "../../../../../../../../react-core/Html/RadiosEditor";
import { isNullOrEmpty } from "../../../../../../../../react-core/Utils/Arrays";
import { CurrencyCode } from "../../../../../../../../Wrap/Constants/Enums/Domain/CurrencyCode";
import { SourceType } from "../../../../../../../../Wrap/Constants/Enums/Domain/SourceType";
import { SubAccountType } from "../../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { MoneyOrPercentage } from "../../../../../../../../Wrap/Models/Models/Shared/MoneyOrPercentage";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../../Shared/Process/Process/ProcessComponent";
import { AdviserChargesContents } from "../../../../Common/AdviserCharges/Resource/Contents";
import { ChargesHelper } from "../../../../Common/Helpers/ChargesHelper";

interface IChargesCopyOptionProps extends IProcessComponentProps {}

interface IChargesCopyOptionState {}

export class ChargesCopyOption extends ProcessComponent<IChargesCopyOptionProps, IChargesCopyOptionState> {
    constructor(props: any) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
        super.componentDidMount();
        const { data, onChange } = this.props;
        if (isNullOrEmpty(data.IsaModel.ChargesExtraInfo?.CopyChargesFromOtherWizard)) {
            if (!data.IsaModel.ChargesExtraInfo) {
                data.IsaModel.ChargesExtraInfo = { CopyChargesFromOtherWizard: false };
            } else {
                data.IsaModel.ChargesExtraInfo.CopyChargesFromOtherWizard = false;
            }
        }
        onChange(data);
    }

    copyCharges(v: boolean) {
        const { data, onChange } = this.props;
        data.IsaModel.ChargesExtraInfo.CopyChargesFromOtherWizard = v;
        if (v) {
            if (ChargesHelper.displayIAC(data.IsaModel, SubAccountType.StocksIsa)) {
                const iac = {...data.PensionApply.InitialAdviserCharge};
                iac.SourceType = SourceType.WrapCash;
                data.IsaModel.InitialAdviserCharge = iac;
            }
            const oac = {...data.PensionApply.OngoingAdviceCharge};
            oac.SourceType = SourceType.WrapCash;
            data.IsaModel.OngoingAdviceCharge = oac;
        } else {
            data.IsaModel.InitialAdviserCharge = this.emptyPercentageOrMoney();
            data.IsaModel.OngoingAdviceCharge = this.emptyPercentageOrMoney();
        }
        onChange(data);
    }

    emptyPercentageOrMoney(): MoneyOrPercentage {
        return {
            Type: null,
            Money: { Amount: null, Currency: CurrencyCode.GBP },
            Percentage: null,
            Frequency: null,
            SourceType: null,
        };
    }

    public render(): JSX.Element {
        const sippProvided = ChargesHelper.chargesProvided(this.props.data.PensionApply);
        if (!sippProvided) {
            return null;
        }
        return (
            <>
                <RadiosEditor
                    cssWrapper="rg-150 mb-24"
                    label={AdviserChargesContents.CopyFromabrdnSipp}
                    options={[true, false]}
                    getText={(v) => (v ? "Yes" : "No")}
                    selected={this.props.data?.IsaModel?.ChargesExtraInfo?.CopyChargesFromOtherWizard}
                    onChange={(v) => this.copyCharges(v)}
                />
            </>
        );
    }
}
